@if (package$ | async; as pkg) {
  <div class="layout-col full gap-md">
    <h4 class="text-title-medium">{{ 'context.identification' | translate }}</h4>
    <div class="layout-row place-start-center gap-md">
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'storageGroups.storageGroup' | translate }}</mat-label>
        <input
          matInput
          name="storageGroupId"
          readonly
          placeholder="-"
          [ngModel]="pkg.storageGroupId"
        />
      </mat-form-field>
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'packages.confirmationState.title' | translate }}</mat-label>
        <elder-select
          appPackageStateSelect
          name="confirmationState"
          readonly
          valueAsId
          [(ngModel)]="pkg.confirmationState"
        >
        </elder-select>
      </mat-form-field>
    </div>
    <div class="layout-row place-start-center gap-md">
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'context.weight' | translate }}</mat-label>
        <elder-quantity-input name="weight" readonly placeholder="-" [(ngModel)]="pkg.weight">
        </elder-quantity-input>
      </mat-form-field>
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'packages.contentDescription' | translate }}</mat-label>
        <input
          matInput
          name="contentDescription"
          readonly
          placeholder="-"
          [(ngModel)]="pkg.contentDescription"
        />
      </mat-form-field>
    </div>
    <div class="layout-row place-start-center gap-md">
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'context.description' | translate }}</mat-label>
        <input matInput name="description" readonly placeholder="-" [(ngModel)]="pkg.description" />
      </mat-form-field>
    </div>
    <div class="layout-row place-start-center gap-md">
      <mat-form-field elderFormFieldLabel>
        <mat-label>{{ 'storage.location' | translate }}</mat-label>
        <input
          matInput
          name="storagePath"
          readonly
          placeholder="-"
          [ngModel]="pkg.location?.storagePath"
        />
        <mat-hint>{{ pkg.location?.checkIn | date: 'medium' }}</mat-hint>
      </mat-form-field>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!pkg?.storageGroupId || !canMove(pkg)"
        (click)="onMove(pkg)"
      >
        {{ 'actions.assign' | translate }}
      </button>
    </div>
  </div>
}
